import styled from 'styled-components';

const Text = styled.p<{ $isSub?: boolean }>`
  font-size: var(${props => (props.$isSub ? '--font-size-text-xs' : '--font-size-text-xl')});
  color: var(--grey-600);
`;

export const SubscriptionConfirmation = () => (
  <>
    <Text>Thanks for subscribing!</Text>
    <Text $isSub>Check your email for a confirmation message.</Text>
  </>
);
